// Direktiva na renderovanie KURZOVEJ PONUKY LOTERIOVYCH HIER (prva - jediná uroven)
directives.lotterySportsbookDirective.sportsBookLG = function() {
    var directive = {
        "#sportLG": {
            "LotteryGame<-": {
                ".@id": "#{LotteryGame.Typ}#{LotteryGame.ID}",
                ".@class+": function () {
                },
                ".@onmousedown": function() {
                    if (this.ParentID && this.ID) {
                        return 'lottery.lotteryGameRender(' + this.ParentID + ', '+ this.ID + ')';
                    }
                },
                ".@order": "LotteryGame.Order",
                ".@style": function() {
                    if (this.ID) {
                        return "background-image: " + "url('" + profile.GraphicSportboxURL + "/cards/lottery-game-" + this.ID + ".png" + "')";
                    }
                }
            }
        }
    }
    T.sportsBookLG = $p("#sportsBookLG").compile(directive);
};
